const buildCoAuthorPayload = ({ paperId, coAuthor }) => ({
  paperId,
  name: coAuthor.name.trim(),
  email: coAuthor.email.trim(),
  phone: coAuthor.phone?.trim() || null,
  specialization: coAuthor.specialization?.trim() || null,
  designation: coAuthor.designation?.trim() || null,
});

const hasRequiredCoAuthorFields = (coAuthor) =>
  coAuthor.name && coAuthor.name.trim() && coAuthor.email && coAuthor.email.trim();

export const savePaperCoAuthors = async ({
  registrationBaseUrl,
  savedPaper,
  existingPaperId,
  coAuthors,
  deleteCoAuthorsByPaperId,
  saveCoAuthor,
}) => {
  if (coAuthors && coAuthors.length > 0) {
    console.log("👥 Saving co-authors for paper ID:", savedPaper.id);

    if (existingPaperId) {
      try {
        console.log("🗑️ Deleting existing co-authors for paper:", savedPaper.id);
        await deleteCoAuthorsByPaperId({
          registrationBaseUrl,
          paperId: savedPaper.id,
        });
        console.log("✅ Existing co-authors deleted");
      } catch (deleteErr) {
        console.error("⚠️ Failed to delete existing co-authors:", deleteErr);
      }
    }

    for (const coAuthor of coAuthors) {
      if (!hasRequiredCoAuthorFields(coAuthor)) {
        continue;
      }

      const coAuthorData = buildCoAuthorPayload({
        paperId: savedPaper.id,
        coAuthor,
      });

      console.log("  - Saving co-author:", coAuthorData);
      const coAuthorResult = await saveCoAuthor({
        registrationBaseUrl,
        payload: coAuthorData,
      });

      if (coAuthorResult.ok) {
        const savedCoAuthor = coAuthorResult.data;
        console.log("  ✅ Co-author saved:", savedCoAuthor);
      } else {
        const errorText = coAuthorResult.errorText;
        console.error("  ❌ Failed to save co-author:", errorText);
      }
    }

    return;
  }

  if (existingPaperId) {
    try {
      console.log("🗑️ Deleting all co-authors for paper:", savedPaper.id);
      await deleteCoAuthorsByPaperId({
        registrationBaseUrl,
        paperId: savedPaper.id,
      });
      console.log("✅ All co-authors deleted");
    } catch (deleteErr) {
      console.error("⚠️ Failed to delete co-authors:", deleteErr);
    }
  }
};
